import {
  CommonModule,
  NgClass,
  NgStyle,
  NgTemplateOutlet,
} from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SharedModule as SharedModuleNG } from 'primeng/api';
import { CarouselComponent } from 'src/app/account/components/carousel/carousel.component';
import { BidBoxHeaderComponent } from '../bid-box-header/bid-box-header.component';
import { BidElementComponent } from '../bid-element/bid-element.component';
import { MemoCarouselComponent } from '../memo-carousel/memo-carousel.component';
import { AuctionView } from './../../../articles-manager/interfaces/auction.interface';

@Component({
  selector: 'app-suggested-auctions',
  templateUrl: './suggested-auctions.component.html',
  styleUrls: ['./suggested-auctions.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    NgStyle,
    NgTemplateOutlet,
    BidElementComponent,
    BidBoxHeaderComponent,
    MemoCarouselComponent,
    SharedModuleNG,
    CommonModule,
    CarouselComponent,
  ],
})
export class SuggestedAuctionsComponent implements OnInit {
  @Input() auctionSuggestions: AuctionView[] = [];
  @Input() isMemorabid: boolean = false;

  responsiveOptions = [
    {
      breakpoint: '4099px',
      numVisible: 20,
      numScroll: 20,
    },
    {
      breakpoint: '3910px',
      numVisible: 19,
      numScroll: 19,
    },
    {
      breakpoint: '3721px',
      numVisible: 18,
      numScroll: 18,
    },
    {
      breakpoint: '3532px',
      numVisible: 17,
      numScroll: 17,
    },
    {
      breakpoint: '3343px',
      numVisible: 16,
      numScroll: 16,
    },
    {
      breakpoint: '3154px',
      numVisible: 15,
      numScroll: 15,
    },
    {
      breakpoint: '2965px',
      numVisible: 14,
      numScroll: 14,
    },
    {
      breakpoint: '2776px',
      numVisible: 13,
      numScroll: 13,
    },
    {
      breakpoint: '2587px',
      numVisible: 12,
      numScroll: 12,
    },
    {
      breakpoint: '2398px',
      numVisible: 11,
      numScroll: 11,
    },
    {
      breakpoint: '2209px',
      numVisible: 10,
      numScroll: 10,
    },
    {
      breakpoint: '2020px',
      numVisible: 9,
      numScroll: 9,
    },
    {
      breakpoint: '1831px',
      numVisible: 8,
      numScroll: 8,
    },
    {
      breakpoint: '1624px',
      numVisible: 7,
      numScroll: 7,
    },
    {
      breakpoint: '1453px',
      numVisible: 6,
      numScroll: 6,
    },
    {
      breakpoint: '1264px',
      numVisible: 5,
      numScroll: 5,
    },
    {
      breakpoint: '1075px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: '887px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: '770px',
      numVisible: 2,
      numScroll: 2,
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
